import React from 'react';
import { Helmet } from 'react-helmet';
import banner from '../assets/galimg/gallery-5.png';
import ServiceGrid from '../components/ServiceGrid';
import ServiceHighlight from '../components/ServiceHighlight'; // <-- Import the new section
import Hero from '../components/Hero';
import { useNavigate } from 'react-router-dom';
import Services from './../components/Services';
import FeaturesSection from './../components/FeaturesSection';
import TechnicalAdvantages from '../components/TechnicalAdvantages';
import MainSpecifications from '../components/MainSpecifications';

const Product = () => {
  const navigate = useNavigate();
  const handleServicesClick = () => {
    navigate('/contact');
  };
  return (
    <>
    <Helmet>
      <link rel="canonical" href="https://driveincarspa.com/product" />
      <title>Top Car Spa Products Bangalore | Premium Car Cleaning & Care | Drive-in Car Spa</title>
      <meta name="description" content="Discover premium car spa products in Bangalore for deep cleaning, shine, and long-lasting protection. Perfect for professionals and car enthusiasts." />
      <meta name="keywords" content=" car wash near me, auto wash products near me,  Top Car Spa Products Bangalore, full car cleaning machine service near me, Premium car spa products in Bangalore " />
       <meta name="author" content="DriveIn Team" />
    </Helmet>
      <Hero
        title={<><span className="highlight">Our Premium Plus</span><br />Machine - Top Car Spa Product in Bangalore </>}
        bgImage={banner}
        onButtonClick={handleServicesClick}
        buttonText="Contact Us"
      />
     <FeaturesSection/>
     <TechnicalAdvantages/>
     <MainSpecifications/>
    </>
  );
};

export default Product;

